module.exports = __webpack_public_path__ + "static/screen-outside-1-2c69990e47638767eacd8f0bd2d5ec02.jpg";